// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'babel-polyfill'
import router from './router'
import axios from 'axios'
import store from './store'
import Confirm from './components/common/Confirm/index'
import toast from './components/toast'

Vue.use(Confirm)
Vue.use(toast)

axios.defaults.timeout = 1000 * 180

// 响应拦截器
axios.interceptors.response.use(
  response => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // 清除token
      store.dispatch('clear_baseinfo')
    }
    Promise.reject(error.response)
  }
)

// （"2018-08-28 09:27:57" => 08-28）
Vue.filter('formatDate', function (value) {
  if (value) {
    return value.substring(0, 10)
  }
})
// 等级转换
Vue.filter('formatGrade', function (value) {
  if (value === 1) {
    return '一'
  } else if (value === 2) {
    return '二'
  } else if (value === 3) {
    return '三'
  } else if (value === 4) {
    return '四'
  } else if (value === 5) {
    return '五'
  } else {
    return ''
  }
})

Vue.prototype.axios = axios
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js